module.exports = __webpack_public_path__ + "static/media/unity.4b20009a.svg";